export function testimonialsSlider() {

    const sliderParent = $('.testimonials-slider-wrap');
    const slider = sliderParent.find('.testimonials-slider');
    const items = slider.find('.item').length;
    let activeSlide = sliderParent.find('.active-slide');
    let totalSlides = sliderParent.find('.total-slides');

    let setCounter = function (activeNumber) {
        activeSlide.html(activeNumber);
        totalSlides.html(items);
    };

    if (items > 9) {
        sliderParent.addClass("many-items");
    }
    if (items > 1) {
        setCounter(1);
        slider.slick({
            infinite: false,
            slidesToShow: 1,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 1.3,
                        adaptiveHeight: false
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 1.29
                    }
                }

            ]
        }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            activeSlide.text(nextSlide + 1);
        })
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialsSlider.js